module.exports = __webpack_public_path__ + "img/result-index-guidance.b44d924c.svg";